<div class="spinner-wrapper">
    <div class="spinner" [class.spinner-white]="white">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
    </div>
</div>